"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var PolarChart = /** @class */ (function (_super) {
    __extends(PolarChart, _super);
    function PolarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarChart.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _radianFunc: function (d) { return d.weight; }, _toolTipFunc: function (d) { return d.type + "-" + d.subtype + "-" + d.value; }, _sortingFunc: function (a, b) { return a.weight - b.weight; }, _radiusFunc: function (d) { return d.scores; }, _categoryFunc: function (d) { return d.id; } });
    };
    PolarChart.prototype._getArcInnerR = function () {
        return function (d, i) { return d.innerR; };
    };
    PolarChart.prototype._getArcOuterR = function () {
        return function (d, i) { return d.outerR; };
    };
    PolarChart.prototype._getRadianData = function () {
        var _this = this;
        this._radianData = d3.pie()
            .padAngle(this.getOption("_padAngle"))
            .value(this.getOption("_radianFunc"))
            .sort(this.getOption("_sortingFunc"))(this.datum);
        var innerRadius = this._getInnerRadius();
        var radiusObjectArray = this.datum.map(this.getOption("_radiusFunc"));
        var keys = Object.keys(radiusObjectArray[0]);
        var radiusSumMax = d3.max(radiusObjectArray.map(function (d) { return keys.reduce(function (a, b) { return a + parseFloat(d[b]); }, 0); }));
        var scale = d3.scaleLinear()
            .domain([0, parseFloat(radiusSumMax)])
            .nice()
            .range([innerRadius, this._outerRadius]);
        var dataAddedRadius = [];
        this._radianData.forEach(function (d, i) {
            var arcInnerRadius = innerRadius;
            keys.forEach(function (s) {
                var originalGap = radiusObjectArray[i][s];
                var cachedGap = scale(originalGap);
                dataAddedRadius.push({
                    innerR: arcInnerRadius,
                    outerR: arcInnerRadius + cachedGap,
                    startAngle: d.startAngle,
                    endAngle: d.endAngle,
                    padAngle: d.padAngle,
                    type: _this.getOption("_categoryFunc").call(null, d.data),
                    subtype: s,
                    value: originalGap,
                });
                arcInnerRadius += cachedGap;
            });
        });
        return dataAddedRadius;
    };
    PolarChart.prototype._getToolTipData = function () {
        return this._radianData.map(this.getOption("_toolTipFunc"));
    };
    return PolarChart;
}(_1.PieChart));
exports.PolarChart = PolarChart;
//# sourceMappingURL=polar-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/polar-chart.js
// module id = 1148
// module chunks = 0 1